import { TextV2 } from 'components/TextV2/TextV2';
import React, { FC } from 'react';
import styles from './FeaturesHeader.module.scss';
import cx from 'classnames';
import { ModalFeatures } from 'api/contentful/contentTypes.cloverdotcom';
import { FlatEntry } from 'services/cms/flattenContentful';
interface IFeaturesModalHeaderProps {
  entries: FlatEntry<ModalFeatures>;
}

export const FeaturesModalHeader: FC<IFeaturesModalHeaderProps> = ({ entries }) => {
  if (!entries.secondaryTitle || !entries.headlineTitle || !entries.blurb?.blurb) return null;

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <TextV2 tagName="h4" variant="eyebrow" className={styles.subtitle} value={entries.secondaryTitle} />
        <TextV2
          value={entries.headlineTitle}
          variant="h4-bold"
          className={cx(styles.title, styles.titlePadding)}
          tagName="h4"
        />
        <TextV2
          value={entries.price?.title}
          variant="h3-bold"
          tagName="h3"
          className={cx(styles.title, styles.titleBottomPadding)}
        />
      </div>
      <TextV2 value={entries.blurb.blurb} variant="body" className={cx(styles.title)} tagName="h4" />
    </div>
  );
};
